import FlooringTableFilter from './flooring-table-filter';

export default FlooringTableFilter;